import { Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import Main from './components/Main';
import Header from './components/Header';
import Footer from './components/Footer';
// import "@fontsource/raleway/400.css";
import "@fontsource/noto-sans/400.css";
import ReactGA from 'react-ga4';

import Contact from './components/Contact';
import Seneca from './components/Seneca';
import Redireccion from './components/Redirect';
import Legal from './components/Legal';
import Cookies from './components/Cookies';
import Privacy from './components/Privacy';
import Quality from './components/Quality';
import Certs from './components/Certs';
import Services from './components/Services';
import Partners from './components/Partners';
import Projects from './components/Projects';
import Igape from './components/Igape';
import Innocamaras from './components/Innocamaras';
import Spica from './components/Spica';
import ProjectForm from './components/ProjectForm';
import Estimate from './components/Estimate';
import { useEffect } from 'react';

import { CookieManager } from "react-cookie-manager";
import "react-cookie-manager/style.css";
import MailPrivacy from './components/MailPrivacy';

function App() {
  ReactGA.initialize('G-MSRMZBYV5D');
  const location = useLocation();

  useEffect(() => { ReactGA.send({ hitType: "pageview", page: window.location.pathname }); }, []);

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location]);

  return (
    <CookieManager enableFloatingButton={true}
      translations={{
        title: "Preferencias de Cookies",
        message: "Valoramos tu privacidad. Utilizamos cookies para mejorar tu experiencia de uso. Elige las cookies que deseas permitir.",
        buttonText: "Aceptar todas",
        declineButtonText: "Declinar todas",
        manageButtonText: "Administrar cookies",
        privacyPolicyText: "Política de privacidad",
        manageTitle: "Preferencias de cookies",
        manageMessage: "A continuación puedes administrar tus preferencias de cookies. Las cookies esenciales siempre están habilitadas, ya que son necesarias para que el sitio web funcione correctamente.",
        manageEssentialTitle: "Esenciales",
        manageEssentialSubtitle: "Necesarias para que el sitio web funcione correctamente",
        manageEssentialStatus: "Estado: Siempre habilitado",
        manageEssentialStatusButtonText: "Siempre activo",
        manageAnalyticsTitle: "Analytics",
        manageAnalyticsSubtitle: "Ayúdanos a entender cómo los visitantes interactúan con nuestro sitio web",
        manageSocialTitle: "Social",
        manageSocialSubtitle: "Habilitar funciones de redes sociales y compartir",
        manageAdvertTitle: "Anuncios",
        manageAdvertSubtitle: "Personalizar anuncios y medir su rendimiento",
        manageCookiesStatus: "Estado: {{status}} el {{date}}",
        manageCookiesStatusConsented: "Consentido",
        manageCookiesStatusDeclined: "Rechazado",
        manageCancelButtonText: "Cancelar",
        manageSaveButtonText: "Guardar preferencias"
      }}
      showManageButton={true}
      privacyPolicyUrl="https://spica.es/politica-de-privacidad"
      theme="light"
      displayType="banner"
      cookieKitId=""
      onManage={(preferences) => {
        if (preferences) {
          console.log("Cookie preferences updated:", preferences);
        }
        window.location.reload()
      }}
      onAccept={() => {
        console.log("User accepted all cookies");
      }}
      onDecline={() => {
        console.log("User declined all cookies");
      }}
    >
      <div className="flex col sbetween acenter">
        <Header />

        <Routes>

          <Route path="/" element={<Main />} />
          <Route path="/nuestros-servicios" element={<Services />} />
          <Route path="/partners-tecnologicos" element={<Partners />} />
          <Route path="/proyectos" element={<Projects />} />
          <Route path="/seneca-video-actas" element={<Seneca />} />
          <Route path="/contacto" element={<Contact />} />
          <Route path="/legal" element={<Legal />} />
          <Route path="/politica-de-cookies" element={<Cookies />} />
          <Route path="/politica-de-privacidad" element={<Privacy />} />
          <Route path="/politica-de-privacidad-de-correos-electronicos" element={<MailPrivacy />} />
          <Route path="/politica-de-calidad-y-medio-ambiente" element={<Quality />} />
          <Route path="/certificaciones" element={<Certs />} />
          <Route path="/presupuesto" element={<Estimate />} />
          <Route path="/igape" element={<Igape />} />
          <Route path="/programa-innocamaras-2020" element={<Innocamaras />} />
          <Route path="/nosotros" element={<Spica />} />
          <Route path="/r" element={<Redireccion />} />
          <Route path="/proyectos/*" element={<ProjectForm />} />

        </Routes>

        <Footer />

      </div>

    </CookieManager>
  )

}

export default App;
